module.exports = __webpack_public_path__ + "img/kit.cd6c2a24.png";